import { EventBroker } from "../../../lib/utils/event-broker";

export const EVENTS = {
    INIT: 'INIT',
    CHANGED: 'CHANGED',
}

export const propertiesModuleEventBroker = new EventBroker();